import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/games/guess-author")({
  beforeLoad: () => {
    throw redirect({ to: "/games/$slug", params: { slug: "who-said-this" } });
  },
  component: () => null,
});
